import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CircleCheckBig, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaAceita = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    // Não capturar "Pendência Aceita" - apenas demandas aceitas
    if (acaoLower.includes('pendência aceita') || acaoLower.includes('pendencia aceita')) {
        return false;
    }
    return acaoLower === 'demanda aceita' || 
           acaoLower.includes('aceitou proposta') ||
           (acaoLower.includes('aceita') && !acaoLower.includes('pendência') && !acaoLower.includes('pendencia'));
};

const getIconDemandaAceita = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: CircleCheckBig, color: 'var(--c2e86de)' };
};

export default function CardDemandaAceita({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaAceita(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const demandaAceitaConfig = {
    tipo: 'demanda_aceita',
    detectaTipo: detectaDemandaAceita,
    getIcon: getIconDemandaAceita,
    temExpansao: () => true,
    Component: CardDemandaAceita
};

